export default class TaskQueue {
  constructor() {
    this.tasks = [];
    this.isProcessing = false;
  }

  addTask(task) {
    this.tasks.push(task);
    // Auto-start processing when a task is added
    this._processNext();
  }

  start() {
    // No-op: processing is now driven by addTask, not polling
  }

  stop() {
    this.isProcessing = false;
  }

  async _processNext() {
    if (this.isProcessing) return;
    const currentTask = this.tasks.shift();
    if (!currentTask) return;

    this.isProcessing = true;
    try {
      await currentTask();
    } catch (err) {
      console.error("Task execution error:", err);
    }
    this.isProcessing = false;
    // Process next task if any
    if (this.tasks.length > 0) {
      this._processNext();
    }
  }

  isQueueEmpty() {
    return this.tasks.length === 0;
  }
}
